/* eslint-disable max-len */
import React, { useState } from 'react'
import Chart, { Title } from 'chart.js/auto';
import DurationDropdown from '../DurationDropDown'
import { Line } from 'react-chartjs-2'
import CityDropdown from '../CityDropdown';
import MerchantDrodown from '../MerchantDrodown';


function LineGraph({
    graphDetails,
    selectedFilter,
    handleSetFilterValues,
    cityList,
    MerchantList,
    Merchecnt,
    Title,
    City,
    Duration,
    handleClearFilter,
    totalCity,
    totalMerchants,
    aspectRatio,
    GraphKey }) {

    const [cityDropdownisOpen, setCityDropdownIsOpen] = useState(false);

   


    const handleFiterOptionClick = (value, key) => {
        console.log(value, 'val')
        handleSetFilterValues(value, GraphKey, key)
        setCityDropdownIsOpen(false);
    }

    const handleCityDropdownClose = () => {
        setCityDropdownIsOpen(false);
    };
    
    return (
        <div className='p-6 w-full'>
            <div className='w-full flex 2xl:flex-row flex-col justify-between items-start'>
                <p className='font-normal text-lg text-[#4B4B4B] w-[70%]'>{Title}</p>
                <div className='flex items-center justify-end w-full'>
                    {Merchecnt !== undefined && <MerchantDrodown
                        MerchantList={MerchantList}
                        handleMerchantOptionClick={handleFiterOptionClick}
                        selectedFilter={selectedFilter.merchant}
                        handleClearFilter={handleClearFilter}
                        GraphKey={GraphKey}
                        totalMerchants={totalMerchants}
                        testId={'merchant'}
                    />}
                    {City !== undefined &&
                        <CityDropdown
                            selectedFilter={selectedFilter.city}
                            buttonDisabled={selectedFilter.merchant && selectedFilter.merchant !== null}
                            cityList={cityList}
                            handleCityOptionClick={handleFiterOptionClick}
                            setCityDropdownIsOpen={setCityDropdownIsOpen}
                            cityDropdownisOpen={cityDropdownisOpen}
                            handleClearFilter={handleClearFilter}
                            GraphKey={GraphKey}
                            handleCityDropdownClose={handleCityDropdownClose} // Pass the function as a prop
                            totalCity={totalCity}
                            testId={'city'}
                        />}
                    {Duration !== undefined && <DurationDropdown
                        handleOptionClick={handleFiterOptionClick}
                        selectedFilter={selectedFilter.duration}
                        testId={'time'}
                        GraphKey={GraphKey}
                    />}
                </div>

            </div>
            <div className='py-5 pl-5 pr-10 w-full'>
                <Line
                    data={{
                        labels: graphDetails?.[selectedFilter.duration]?.map((data) => data.label),
                        datasets: [
                            {
                                label: "",
                                data: graphDetails?.[selectedFilter.duration]?.map((data) => data.value),
                                backgroundColor: "#9E2064",
                                borderColor: "#9E2064",
                            },
                        ],
                    }}
                    options={{
                        aspectRatio:aspectRatio ? 3 :null,
                        plugins: {
                            title: {
                                text: "Number of Products Scanned",
                            },
                            legend: {
                                display: false // Remove legend
                            }
                        },
                        scales: {
                            x: {
                                grid: {
                                    display: false, // Remove y-axis grid lines
                                },
                                beginAtZero: true,
                                ticks: {
                                    stepSize: 3// Increase the gap between y-axis ticks
                                }
                            },

                            y: {
                                border: {
                                    dash: [6, 6],
                                    color: '#efefef'
                                },
                                grid: {
                                    borderDash: [10, 10], // Set x-axis grid lines as dotted
                                },
                                beginAtZero: true,
                            },
                        }
                    }}
                />
                <p className='mt-4 text-center w-full flex items-center justify-center font-normal text-xs text-black'>
                    <span className='bg-[#9E2064] h-1 w-4 mr-3'></span>
                    {graphDetails?.[selectedFilter.duration]?.[0].label}
                    <span style={{ margin: '0 10px' }}>-</span>
                    {graphDetails?.[selectedFilter.duration]?.[graphDetails[selectedFilter.duration].length - 1]?.label}
                </p>
            </div>
        </div>
    )
}

export default LineGraph;